import { CheckboxListControl, FormCol, FormRow, useScopedSelector } from 'ia-react-core';
import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledP, StyledCheckboxItem, StyledCheckboxItemContract, StyledCheckboxListControlWrapper } from './DocumentProductRow.styles';
import { DocumentsState } from '../../../../../interfaces/DocumentsState';
import { selectContracts } from './selectContracts';
import useCheckBoxDefaultValue from '../hooks/useCheckBoxDefaultValue';
import Constants from '../../../../../Constants';

export interface DocumentProductRowProps { }

const DocumentProductRow: FC<DocumentProductRowProps> = () => {
  const { t } = useTranslation('Documents');
  const documentGroups = useScopedSelector((state: DocumentsState) => state.groups);
  const documentContracts = selectContracts(documentGroups);

  const options = useMemo(() => documentContracts.map((x) => ({
    label: <StyledP><StyledCheckboxItem>{x.contractName}</StyledCheckboxItem><StyledCheckboxItemContract>{x.contractNumber}</StyledCheckboxItemContract></StyledP>,
    value: `${x.contractNumber}-${x.systemCode}`,
  })), [documentContracts]);

  const checkBoxDefaultValue = useCheckBoxDefaultValue(Constants.DefaultContractsParam, options);

  return (
    <FormRow>
      <FormCol label={t('product')}>
        <StyledCheckboxListControlWrapper>
          <CheckboxListControl<string, string>
            name="product"
            options={options}
            noBox
            defaultValue={checkBoxDefaultValue}
          />
        </StyledCheckboxListControlWrapper>
      </FormCol>
    </FormRow>
  );
};

export default DocumentProductRow;
